import React from "react";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Button, TextField } from "@mui/material";
import FileUpload from '@mui/icons-material/FileUpload';

import './ExpenseValidation.css';
import ExpenseService from "../../Services/ExpenseService";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import Swal from "sweetalert2";
import { ShowBlocker } from "../../Components/LoaderComponent/LoaderComponent";

interface Istate {
    state_id: string;
    state_name: string;
    state_code: string;
}

interface IOperatingCost {
    oneCar: number;
    twoCars: number;
    location: string;
    id: string;
}

interface IOutOfPocketExpense {
    underSixtyFive: number,
    sixtyFiveAndOlder: number
}

interface IPublicTransportation {
    amount: number
}

interface IOwnershipCost {
    oneCar: number;
    twoCars: number;
}

interface IFoodClothingMisc {
    onePerson: number,
    twoPerson: number,
    threePerson: number,
    fourPerson: number,
    additonalPerson: number
}

interface IExpenseType {
    actualName: string;
    displayName: string;
}

interface IEVState {
    selectedexpenseType: string;
    accessToken: string;
    expenseTypes: IExpenseType[];
    foodClothingMisc: IFoodClothingMisc;
    outOfPocketExpense: IOutOfPocketExpense;
    ownershipCost: IOwnershipCost;
    operatingCost: IOperatingCost[];
    publicTransportation: IPublicTransportation;
    states: Istate[];
    selectedState: string;
    base64String: string;
    fileName: string;
    selectedOperatingCost: IOperatingCost;
    validationErrors: { [key: string]: string };
}

class ExpenseValidation extends React.Component<{}, IEVState> {

    constructor(porps_: any) {
        super(porps_);
        this.state = {
            selectedexpenseType: '',
            accessToken: '',
            expenseTypes: [],
            foodClothingMisc: { onePerson: 0, twoPerson: 0, threePerson: 0, fourPerson: 0, additonalPerson: 0 },
            outOfPocketExpense: { sixtyFiveAndOlder: 0, underSixtyFive: 0 },
            ownershipCost: { oneCar: 0, twoCars: 0 },
            operatingCost: [],
            selectedOperatingCost: { location: '', oneCar: 0, twoCars: 0, id: '' },
            publicTransportation: { amount: 0 },
            states: [],
            selectedState: '',
            base64String: '',
            fileName: '',
            validationErrors: {}
        };
    }

    async componentDidMount() {
        const accesstoken = await loadFromLocalStorage('accessToken');
        if (accesstoken) {
            this.setState({ accessToken: accesstoken.toString() }, () => {
                this.getExpenseTypes();
            });
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    }

    getExpenseTypes() {
        ExpenseService.getExpenseTypes(this.state.accessToken).then(r => {
            r.json().then(resp => {
                this.setState({ expenseTypes: resp });
            });
        });
    }

    expenseTypeHandler(event: any) {
        this.setState({ selectedexpenseType: event.target.value }, () => {
            if (this.state.selectedexpenseType !== 'housing_and_utilities') {
                this.getExpenseDetails();
            } else {
                this.getStates();
            }
        });
    }

    getStates() {
        ExpenseService.getAllStates(this.state.accessToken).then(r => {
            r.json().then(resp => {
                this.setState({ states: [...resp] });
            });
        });
    }

    stateHandler(event: any) {
        this.setState({ selectedState: event.target.value });
    }

    operatingCostHandler(event: any) {
        let selectedVal = this.state.operatingCost.filter(x => x.id === event.target.value)[0];
        this.setState({ selectedOperatingCost: selectedVal });
    }

    getExpenseDetails() {
        this.setState({validationErrors:{}});
        ExpenseService.getExpenseDetails({ expenseType: this.state.selectedexpenseType }, this.state.accessToken).then((r => {
            r.json().then((resp: any) => {
                switch (this.state.selectedexpenseType) {
                    case 'food_clothing_misc':
                        this.setState({ foodClothingMisc: resp.values });
                        break;
                    case 'out_of_pocket_costs':
                        this.setState({ outOfPocketExpense: resp.values });
                        break;
                    case 'ownership_costs':
                        this.setState({ ownershipCost: resp.values });
                        break;
                    case 'public_transportation':
                        this.setState({ publicTransportation: resp.values });
                        break;
                    case 'operating_costs':
                        this.setState({ operatingCost: resp.values });
                        break;
                }
            });
        }));
    }

    validateDecimalInput = (value: string): string => {
        const regex = /^\d*\.?\d*$/;
        if (value === "") return "This field is required.";
        if (!regex.test(value)) return "Only numeric and decimal values are allowed.";
        return "";
    }

    mapFoodInput(input: string) {
        return {
            onePersonAmnt: "onePerson",
            twoPersonAmnt: "twoPerson",
            threePersonAmnt: "threePerson",
            fourPersonAmnt: "fourPerson",
            addPersonAmnt: "additonalPerson"
        }[input] || input;
    }

    foodClothMiscInputHandler(event: any, input: string) {
        const value = event.target.value;
        const error = this.validateDecimalInput(value);
        const mappedKey = this.mapFoodInput(input);

        this.setState(prevState => ({
            foodClothingMisc: { ...prevState.foodClothingMisc, [mappedKey]: value },
            validationErrors: { ...prevState.validationErrors, [input]: error }
        }));
    }

    outOfPocketHandler(event: any, input: string) {
        const value = event.target.value;
        const error = this.validateDecimalInput(value);

        this.setState(prevState => ({
            outOfPocketExpense: { ...prevState.outOfPocketExpense, [input === 'underSixtyFive' ? 'underSixtyFive' : 'sixtyFiveAndOlder']: value },
            validationErrors: { ...prevState.validationErrors, [input]: error }
        }));
    }

    ownershipCostHandler(event: any, input: string) {
        const value = event.target.value;
        const error = this.validateDecimalInput(value);

        this.setState(prevState => ({
            ownershipCost: { ...prevState.ownershipCost, [input]: value },
            validationErrors: { ...prevState.validationErrors, [input]: error }
        }));
    }

    operatingCostInputHandler(event: any, input: string) {
        const value = event.target.value;
        const error = this.validateDecimalInput(value);

        this.setState(prevState => ({
            selectedOperatingCost: { ...prevState.selectedOperatingCost, [input]: value },
            validationErrors: { ...prevState.validationErrors, [input]: error }
        }));
    }

    publicTransportation(event: any, input: string) {
        const value = event.target.value;
        const error = this.validateDecimalInput(value);

        this.setState(prevState => ({
            publicTransportation: { amount: value },
            validationErrors: { ...prevState.validationErrors, ["publicTransportation"]: error }
        }));
    }

    handleFileChange = (event: any) => {
        ShowBlocker(true);
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const result = reader.result;
            if (typeof result === "string") {
                this.setState({ base64String: result.split(",")[1], fileName: file.name });
            }
            ShowBlocker(false);
        };
        reader.onerror = (error) => {
            console.error("Error reading file:", error);
            ShowBlocker(false);
        };
    }

    updateExpense() {
        let validationErrors: any = {};
        let valid = true;
        let postData: any = { expenseType: this.state.selectedexpenseType };
        switch (this.state.selectedexpenseType) {
            case 'housing_and_utilities':
                if (!this.state.selectedState) {
                    validationErrors["selectedState"] = "State selection is required.";
                    valid = false;
                }
                if (!this.state.base64String) {
                    validationErrors["base64String"] = "File upload is required.";
                    valid = false;
                }
                postData["housingAndUtilities"] = {
                    base64: this.state.base64String,
                    stateId: this.state.selectedState
                };
                break;
            case 'food_clothing_misc':
                ["onePerson", "twoPerson", "threePerson", "fourPerson", "additonalPerson"].forEach(field => {
                    const value = (this.state.foodClothingMisc as any)[field];
                    const error = this.validateDecimalInput(value.toString());
                    if (error) valid = false;
                    validationErrors[field] = error;
                });
                postData["foodClothingAndMisc"] = {
                    onePersonAmount: this.state.foodClothingMisc.onePerson,
                    twoPersonAmount: this.state.foodClothingMisc.twoPerson,
                    threePersonAmount: this.state.foodClothingMisc.threePerson,
                    fourPersonAmount: this.state.foodClothingMisc.fourPerson,
                    additionalPersonAmount: this.state.foodClothingMisc.additonalPerson
                };
                break;
            case 'out_of_pocket_costs':
                ["underSixtyFive", "sixtyFiveAndOlder"].forEach(field => {
                    const value = (this.state.outOfPocketExpense as any)[field];
                    const error = this.validateDecimalInput(value.toString());
                    if (error) valid = false;
                    validationErrors[field] = error;
                });
                postData["outOfPocketCost"] = {
                    underSixtyFive: this.state.outOfPocketExpense.underSixtyFive,
                    sixtyFiveAbove: this.state.outOfPocketExpense.sixtyFiveAndOlder
                };
                break;
            case 'ownership_costs':
                ["oneCar", "twoCars"].forEach(field => {
                    const value = (this.state.ownershipCost as any)[field];
                    const error = this.validateDecimalInput(value.toString());
                    if (error) valid = false;
                    validationErrors[field] = error;
                });
                postData["ownershipCost"] = {
                    oneCarAmnt: this.state.ownershipCost.oneCar,
                    twoCarsAmnt: this.state.ownershipCost.twoCars
                };
                break;
            case 'operating_costs':
                ["oneCar", "twoCars"].forEach(field => {
                    const value = (this.state.selectedOperatingCost as any)[field];
                    const error = this.validateDecimalInput(value.toString());
                    if (error) valid = false;
                    validationErrors[field] = error;
                });
                postData["operatingCost"] = {
                    oneCarAmnt: this.state.selectedOperatingCost.oneCar,
                    twoCarsAmnt: this.state.selectedOperatingCost.twoCars,
                    location: this.state.selectedOperatingCost.id
                };
                break;
            case 'public_transportation':
                const value = this.state.publicTransportation.amount;
                const error = this.validateDecimalInput(value.toString());
                if (error) valid = false;
                validationErrors["publicTransportation"] = error;
                postData["publicTransportation"] = {
                    amount: this.state.publicTransportation.amount,
                };
                break;
        }

        // this.setState({ validationErrors });

        if (!valid) {
            Swal.fire("Error", "Please fix validation errors before submitting.", "error");
            return;
        }

        // original API submission logic continues...
        ExpenseService.updateExpenseDetails(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then(resp => {

                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Updated expense details for ${this.state.selectedexpenseType.toUpperCase().replaceAll("_"," ")} successfully`,

                    }).then((result) => {
                        this.getExpenseDetails();
                      });;

                });
            }

        });
    }

      /**
     * Based on the expense type chosen it will return the associated html elements to the expense type that will
     * get displayed in the first row
     * @returns 
     */
      firstRow() {
        switch (this.state.selectedexpenseType) {
            case 'housing_and_utilities':
                return (<>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{
                            m: 1, width: '100%'
                        }} error={Boolean(this.state.validationErrors["selectedState"])}>
                        

                            <InputLabel id="demo-simple-select-standard-label">State </InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-helper"
                                label="State "
                                onChange={(event) => this.stateHandler(event)}>
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                
                                {this.state.states.map(x => {
                                    return (
                                        <MenuItem value={x.state_id}>{x.state_name}</MenuItem>
                                    );
                                })}
                            </Select>
                            {this.state.validationErrors["selectedState"] && (
        <p style={{ color: 'red', margin: '4px 0 0 14px' }}>
            {this.state.validationErrors["selectedState"]}
        </p>
    )}
                        </FormControl>
                    </div>
                </>);
            case 'food_clothing_misc':
                return (<>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%', textAlign:'left' }}>
                            <TextField id="outlined-basic" label="One Person Amount" variant="outlined" 
                            value={this.state.foodClothingMisc.onePerson}
                            onInput={(event) => this.foodClothMiscInputHandler(event, "onePersonAmnt")}
                            error={Boolean(this.state.validationErrors["onePersonAmnt"])}
                            helperText={this.state.validationErrors["onePersonAmnt"]} />
                        </FormControl>
                    </div>
                </>);
            case 'out_of_pocket_costs':
                return (<>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%' ,textAlign:'left'}}>
                            <TextField id="outlined-basic" label="Allowed expense for age under sixty five" variant="outlined" 
                            value={this.state.outOfPocketExpense.underSixtyFive} 
                            onInput={(event) => this.outOfPocketHandler(event, "underSixtyFive")} 
                            error={Boolean(this.state.validationErrors["underSixtyFive"])}
                            helperText={this.state.validationErrors["underSixtyFive"]}/>
                        </FormControl>
                    </div>
                </>);
            case 'ownership_costs':
                return (<>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%',textAlign:'left' }}>
                            <TextField id="outlined-basic" label="One car amount" variant="outlined" 
                            value={this.state.ownershipCost.oneCar} 
                            onInput={(event) => this.ownershipCostHandler(event, 'oneCar')}
                            error={Boolean(this.state.validationErrors["oneCar"])}
                            helperText={this.state.validationErrors["oneCar"]} />
                        </FormControl>
                    </div>
                </>);
            case 'public_transportation':
                return (<>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%',textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Amount" variant="outlined" 
                            value={this.state.publicTransportation.amount} 
                            onInput={(event) => this.publicTransportation(event, '')} 
                            error={Boolean(this.state.validationErrors["publicTransportation"])}
                            helperText={this.state.validationErrors["publicTransportation"]}/>
                        </FormControl>
                    </div>
                </>);
            case 'operating_costs':
                return (<>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%' }}>
                            <InputLabel id="demo-simple-select-standard-label">Location </InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-helper"
                                label="Location"
                                onChange={(event) => this.operatingCostHandler(event)}>
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {this.state.operatingCost.map(x => {
                                    return (
                                        <MenuItem value={x.id}>{x.location}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>
                </>);
        }
    }

    /**
     * Based on the expense type chosen it will return the associated html elements to the expense type that will
     * get displayed in the second row
     * @returns 
     */
    secondRow() {
        console.log('switch')
        switch (this.state.selectedexpenseType) {
            case 'housing_and_utilities':
                return (<>
                    <div className="expense-col-one">

                        <input
                            type="file"
                            accept=".xlsx"
                            id="file-upload"
                            style={{ display: "none" }}
                            onChange={(event) => this.handleFileChange(event)}
                            disabled={!this.state.selectedState} // Simplified
                        />
                        <button
                            className="expense-file-upload"
                            onClick={() => document.getElementById("file-upload")?.click()}
                            disabled={!this.state.selectedState}
                        >
                            <span style={{ textAlign: 'center', fontSize: '16px', display: 'inline' }}>Upload File</span> <FileUpload style={{ fontSize: "20px", marginLeft: '5px', textAlign: 'center' }}></FileUpload>
                        </button>
                        <p>{this.state.fileName}</p>

                    </div>
                    {/* <div style={{ width: '50%' }}>
                        <div style={{ margin: '10px', width: '100%', fontSize: '1.3rem' }}>
                            <p> expenseDetails.xlsx</p>
                        </div>
                    </div> */}
                </>);
            case 'food_clothing_misc':
                return (<>
                    <div className="expense-col-one">
                        <FormControl id='et' sx={{ m: 1, width: '100%', textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Two person amount" variant="outlined" value={this.state.foodClothingMisc.twoPerson} 
                            onInput={(event) => this.foodClothMiscInputHandler(event, "twoPersonAmnt")}
                            error={Boolean(this.state.validationErrors["twoPersonAmnt"])}
                            helperText={this.state.validationErrors["twoPersonAmnt"]} />
                        </FormControl>
                    </div>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%',textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Three person amount" variant="outlined" value={this.state.foodClothingMisc.threePerson} 
                            onInput={(event) => this.foodClothMiscInputHandler(event, "threePersonAmnt")} 
                            error={Boolean(this.state.validationErrors["threePersonAmnt"])}
                            helperText={this.state.validationErrors["threePersonAmnt"]}/>
                        </FormControl>
                    </div>
                </>);
            case 'out_of_pocket_costs':
                return (<>
                    <div className="expense-col-one">
                        <FormControl id='et' sx={{ m: 1, width: '100%',textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Allowed expense for age sixty five and above" variant="outlined" 
                            value={this.state.outOfPocketExpense.sixtyFiveAndOlder} 
                            onInput={(event) => this.outOfPocketHandler(event, "sixtyFiveAbove")}
                            error={Boolean(this.state.validationErrors["sixtyFiveAbove"])}
                            helperText={this.state.validationErrors["sixtyFiveAbove"]} />
                        </FormControl>
                    </div>
                </>);
            case 'ownership_costs':
                return (<>
                    <div className="expense-col-one">
                        <FormControl id='et' sx={{ m: 1, width: '100%',textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Two cars amount" variant="outlined" 
                            value={this.state.ownershipCost.twoCars} 
                            onInput={(event) => this.ownershipCostHandler(event, 'twoCars')} 
                            error={Boolean(this.state.validationErrors["twoCars"])}
                            helperText={this.state.validationErrors["twoCars"]}/>
                        </FormControl>
                    </div>
                </>);
            case 'operating_costs':
                return (<>
                    <div className="expense-col-one">
                        <FormControl id='et' sx={{ m: 1, width: '100%', textAlign:'left' }}>
                            <TextField id="outlined-basic" label="One car amount" variant="outlined" 
                            value={this.state.selectedOperatingCost.oneCar} 
                            onInput={(event) => this.operatingCostInputHandler(event, 'oneCar')}
                            error={Boolean(this.state.validationErrors["oneCar"])}
                            helperText={this.state.validationErrors["oneCar"]} />
                        </FormControl>
                    </div>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%', textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Two car amount" variant="outlined" 
                            value={this.state.selectedOperatingCost.twoCars} 
                            onInput={(event) => this.operatingCostInputHandler(event, 'twoCars')}
                            error={Boolean(this.state.validationErrors["twoCars"])}
                            helperText={this.state.validationErrors["twoCars"]} />
                        </FormControl>
                    </div>
                </>);

        }
    }

    /**
     * Based on the expense type chosen it will return the associated html elements to the expense type that will
     * get displayed in the third row
     * @returns 
     */
    thirdRow() {
        switch (this.state.selectedexpenseType) {
            case 'food_clothing_misc':
                return (<>
                    <div className="expense-col-one">
                        <FormControl id='et' sx={{ m: 1, width: '100%', textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Four person amount" variant="outlined" 
                            value={this.state.foodClothingMisc.fourPerson}
                            onInput={(event) => this.foodClothMiscInputHandler(event, "fourPersonAmnt")} 
                            error={Boolean(this.state.validationErrors["fourPersonAmnt"])}
                            helperText={this.state.validationErrors["fourPersonAmnt"]}/>   
                        </FormControl>
                    </div>
                    <div style={{ width: '50%' }}>
                        <FormControl id='et' sx={{ m: 1, width: '100%', textAlign:'left' }}>
                            <TextField id="outlined-basic" label="Additional person amount" variant="outlined" 
                            value={this.state.foodClothingMisc.additonalPerson}
                             onInput={(event) => this.foodClothMiscInputHandler(event, "addPersonAmnt")} 
                             error={Boolean(this.state.validationErrors["addPersonAmnt"])}
                             helperText={this.state.validationErrors["addPersonAmnt"]}/>
                        </FormControl>
                    </div>
                </>);
        }
    }

    public render() {
        return (
            <div className="expense-container">
                <h2> Update Expense Details</h2>
                <div className="expense-input-row">
                    <div className="expense-col-one">
                        <FormControl id='et' sx={{ m: 1, width: '100%' }} >
                            <InputLabel id="demo-simple-select-standard-label">Expense Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="Expense Type"
                                onChange={(event) => this.expenseTypeHandler(event)}>
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {this.state.expenseTypes.map(x => {
                                    return (
                                        <MenuItem value={x.actualName}>{x.displayName}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    {this.firstRow()}
                </div>
                {this.state.selectedexpenseType != '' && <div className="expense-input-row">
                    {this.secondRow()}
                </div>}
                {this.state.selectedexpenseType != '' && <div className="expense-input-row">
                    {this.thirdRow()}
                </div>}
                {this.state.selectedexpenseType != '' && <div className="expense-input-row">
                    <button className="expense-Action-btn" onClick={(event) => this.updateExpense()} ><p><b>Update Expense</b></p></button>
                </div>}
            </div>
        );
    }
}

export default ExpenseValidation;
